<template>
  <div class="content-widget__block">
    <div class="row">
      <div class="col-xl-10">
        <h3
          v-if="block.title"
          v-html="block.title"
        ></h3>
        <div
          class="text-content"
          v-html="block.content"
        ></div>
        <div
          v-if="hasDefaultSlot"
          class="content-widget__block-button"
        >
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ContentWidgetBlock',
    props: {
      block: {
        type: Object,
        default: () => {}
      }
    },
    computed: {
      hasDefaultSlot() {
        return !!this.$slots.default
      }
    }
  }
</script>

<style lang="scss">
  .content-widget__block {
    .text-content {
      p:last-child {
        margin-bottom: 0;
      }
    }
  }

  .content-widget__block-button {
    margin-top: 40px;
  }
</style>